export default "__VITE_ASSET__DnTQFLcU__"